/**
 * AB drop preview : blocage du checkout côté client.
 *
 * Les lignes du panier portent data-ab-preview="true|false" (rendu serveur,
 * regénéré à chaque update AJAX via la Section Rendering API du thème). Le
 * bouton de checkout, lui, est HORS du <cart-items> re-rendu : on le bascule
 * donc en JS à chaque mutation du panier. Le <p data-ab-preview-message> est
 * toujours présent dans le DOM (rendu Liquid) ; on ne fait que basculer hidden.
 *
 * Détection = présence d'au moins une ligne data-ab-preview="true". La source
 * de vérité reste le metafield larriereboutique.drop_state lu côté Liquid.
 */
(function () {
  'use strict';

  function recompute() {
    var hasPreview = document.querySelector('[data-ab-preview="true"]') !== null;

    document.querySelectorAll('[data-ab-checkout-btn]').forEach(function (btn) {
      btn.disabled = hasPreview;
      btn.setAttribute('aria-disabled', hasPreview ? 'true' : 'false');
    });

    document.querySelectorAll('[data-ab-preview-message]').forEach(function (msg) {
      msg.hidden = hasPreview ? false : true;
    });

    // Boutons de paiement express (PayPal, Shop Pay, etc.). Cote serveur ils ne
    // sont PAS rendus quand le panier contient deja un preview ; ce toggle couvre
    // le cas ou un preview est ajoute a un panier qui n'en avait pas (le bloc,
    // injecte par le SDK de paiement, est deja dans le DOM et ne peut etre recree
    // en JS, donc on le masque plutot que de le supprimer). display inline pour
    // l'emporter sur le flex du theme.
    document.querySelectorAll('[data-ab-express-buttons]').forEach(function (el) {
      el.style.display = hasPreview ? 'none' : '';
    });
  }

  function init() {
    recompute();

    // Voie A : bus pub/sub du thème (canonique, PUB_SUB_EVENTS.cartUpdate).
    if (typeof window.subscribe === 'function') {
      window.subscribe('cart-update', recompute);
    }

    // Voie A bis : CustomEvents DOM émis par le thème.
    // theme:product:added est le SEUL signal émis APRES enableCartButtons() dans
    // build() : ce dernier fait removeAttribute('disabled') sur tous les boutons
    // du panier (y compris le checkout) a chaque update de quantite. Les autres
    // events (theme:cart:change) arrivent avant et seraient ecrases.
    ['theme:cart:change', 'theme:cart:update', 'theme:cart:add', 'theme:product:added'].forEach(function (evt) {
      document.addEventListener(evt, recompute);
    });

    // Voie B (filet) : observer les conteneurs panier (re-render hors événements).
    var targets = document.querySelectorAll('cart-items, #cart-drawer, [data-checkout-buttons]');
    if (targets.length) {
      var observer = new MutationObserver(recompute);
      targets.forEach(function (node) {
        observer.observe(node, { childList: true, subtree: true });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
